export const splitArr = arr => {
  const halfIdx = Math.ceil(arr.length / 2)
  return [arr.slice(0, halfIdx), arr.slice(halfIdx)]
}
